require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-open-house-fourdrinier-house-by-techne-architecture.json") })
        }
      }, "path---news-open-house-fourdrinier-house-by-techne-architecture");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-open-house-fourdrinier-house-by-techne-architecture!./.cache/json/news-open-house-fourdrinier-house-by-techne-architecture.json
// module id = 837
// module chunks = 231608221292675